/**
 * Utility functions for date and time formatting
 */

/**
 * Format timestamp by removing 'T', '.', 'Z' and truncating to remove milliseconds
 * @param {string} time - ISO timestamp string
 * @returns {string} - Formatted time string
 */
export const formatTimestamp = (time) => {
  if (!time) return '';
  
  let formattedTime = time
    .replace('T', ' ')
    .replace('.', '')
    .replace('Z', '');
    
  // Remove milliseconds (last 3 characters)
  formattedTime = formattedTime.substring(0, formattedTime.length - 3);
  
  return formattedTime;
};

/**
 * Convert boolean to Yes/No string
 * @param {boolean} correct - Boolean value to convert
 * @returns {string} - "Yes" or "No"
 */
export const formatBooleanResult = (correct) => {
  return correct ? "Yes" : "No";
};